/**
 * Currency configuration for the application
 * This file centralizes currency settings with support for country-based currency
 */

import { getCurrencyForCountry, formatCurrency } from './currencyMapping';

const currencyConfig = {
  // Default currency (used when no country is specified)
  defaultSymbol: '£',
  defaultCode: 'GBP',
  defaultPosition: 'before',

  /**
   * Get currency info for a specific country
   * @param {string} country - Country name or code
   * @returns {object} Currency information
   */
  getCurrency: (country) => {
    return getCurrencyForCountry(country);
  },

  /**
   * Format a number as currency for a specific country
   * @param {number} amount - The amount to format
   * @param {string} country - Country name or code (optional)
   * @returns {string} Formatted currency string
   */
  format: (amount, country = null) => {
    if (country) {
      return formatCurrency(amount, country);
    }

    // Default behavior (GBP)
    const num = parseFloat(amount || 0);
    return `${currencyConfig.defaultSymbol}${num.toFixed(2)}`;
  },

  /**
   * Get user's country from localStorage
   * @returns {string|null} User's country or null
   */
  getUserCountry: () => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        return user.country || null;
      }
    } catch (e) {
      console.error('Error getting user country:', e);
    }
    return null;
  },

  /**
   * Format amount using logged-in user's currency
   * @param {number} amount - The amount to format
   * @returns {string} Formatted currency string
   */
  formatForUser: (amount) => {
    const country = currencyConfig.getUserCountry();
    return currencyConfig.format(amount, country);
  }
};

export default currencyConfig;
